import { utils } from '@/utils';

const apiHost =
  utils.constants.ASTUR_DEFAULTS.defaultConfig === 'prd'
    ? utils.constants.ASTUR_DEFAULTS.config.prd.apiHost
    : utils.constants.ASTUR_DEFAULTS.config.dev.apiHost;

export const API_BASE_URL = apiHost.startsWith('http') ? apiHost : `https://${apiHost}/v1`;
